import React from 'react';

import { ModalBody, ModalCloseBtn, ModalContent, ModalFooter, ModalHeader } from '@fiverr-private/overlay';
import { Button } from '@fiverr-private/button';
import { I18n } from '@fiverr-private/i18n-react';
import { Typography } from '@fiverr-private/typography';
import { useComplianceContext } from '../ComplianceProvider/context';

export function BackgroundCheckRequestSuccessPopup({ name = '' }: { name: string }) {
    const ComplianceContext = useComplianceContext();

    if (!ComplianceContext) return null;

    return (
        <ModalContent size="sm">
            <ModalHeader>
                <I18n k={'compliance.popups.background_request_success.title'} />
                <ModalCloseBtn onClick={ComplianceContext.popupApi.close} />
            </ModalHeader>
            <ModalBody>
                <Typography textAlign={'center'}>
                    <I18n k={'compliance.popups.background_request_success.body'} params={{ name }} />
                </Typography>
            </ModalBody>
            <ModalFooter>
                <Button onClick={ComplianceContext.popupApi.close}>
                    <I18n k={'compliance.popups.background_request_success.action'} />
                </Button>
            </ModalFooter>
        </ModalContent>
    );
}
